














import Vue from "vue";
// import ProjectsList from "@/components/ProjectsList.vue";
import otherProjectsData from "@/data/OtherProjectsData.ts";

export default Vue.extend({
  name: "OtherProjects",
  components: {
    // ProjectsList,
  },
  data: function () {
    return {
      projects: otherProjectsData,
    };
  },
});
